import { render, staticRenderFns } from "./DonutChart33.vue?vue&type=template&id=413f11e4&scoped=true&"
import script from "./DonutChart33.vue?vue&type=script&lang=js&"
export * from "./DonutChart33.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413f11e4",
  null
  
)

export default component.exports